import { render, staticRenderFns } from "./GuardianshipAffidavit.vue?vue&type=template&id=704a6840"
import script from "./GuardianshipAffidavit.vue?vue&type=script&lang=ts"
export * from "./GuardianshipAffidavit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports